import merge from 'lodash/merge';

import DatabaseSelect from '@/modules/corporate/modules/database/fields/components/DatabaseSelect';

import { FilterInputProps } from '../../types';
import { FILTER_INPUT_HEIGHT, getClasses, getFilterInputClasses } from '../styles';

function SelectFilterInput(props: FilterInputProps) {
  const { value, onChange, field, multiple } = props;
  const classes = merge(
    getClasses(FILTER_INPUT_HEIGHT),
    getFilterInputClasses(FILTER_INPUT_HEIGHT),
  );

  return (
    <DatabaseSelect
      classes={classes}
      field={field}
      multiple={multiple}
      openOnFocus={false}
      value={value || ''}
      onChange={onChange}
    />
  );
}

export default SelectFilterInput;
